<template>

<div>

	<!-- show loading indicator -->
	<loading-indicator :loading="isLoading"></loading-indicator>

	<template v-if="!isLoading">

		<!-- page-heading -->
		<page-heading :show="true" :pageTitle="title"></page-heading>

		<div class="columns">

			<div class="col-main" style="overflow: visible; z-index: 0;">

				<div class="box">

					<form-input inputType="text" label="EC-NAME" inputSize="is-medium" v-model="equipmentCategory.name" :isHorizontal="true"></form-input>

					<!-- v-if="!isNewEquipmentCategory" -->
					<div class="control is-horizontal">
						<div class="control-label">
							<label-name labelKey="EC-CATEGORY_ALIASES"></label-name>
						</div>
						<div class="control">
							<multiselect
								v-model="existingTags"
								tag-placeholder="als neuen Alias speichern"
								selectedLabel="ausgewählt"
								selectLabel="Enter für Auswahl"
								deselectLabel="Enter für Entfernen"
								placeholder="Suchbegriff eingeben"
								label="name"
								track-by="name"
								:options="taggingOptions"
								:multiple="true"
								:taggable="true"
								:optionsLimit="5"
								@tag="categoryAliasAdd"
								class="tagging">
							</multiselect>
						</div>
					</div>

					<form-input inputType="text" label="EC-COLUMNS" inputSize="is-medium" v-model="equipmentCategory.columns" :isHorizontal="true"></form-input>

				</div>

			</div>

      <div class="col-aside">

				<affix :offset="50">

					<div class="sidebox">

						<custom-button type="blue" icon="icon-ak-speichern" name="EC-BTN-SAVE" :loading="isSaving" @click.native="submitForm()" :class="{'is-disabled': isReadOnly}"></custom-button>

						<template v-if="!isNewEquipmentCategory && equipmentCategory.pages && equipmentCategory.pages.length == 0">
							<custom-button type="dark" icon="icon-ak-entfernen" name="EC-BTN-DELETE" @click.native="deleteEquipmentCategory()" :class="{'is-disabled': isReadOnly}"></custom-button>
						</template>

					</div>

				</affix>

      </div>

    </div>

	</template>

</div>
</template>



<script>
import Multiselect from 'vue-multiselect'

export default {

    name: 'equipmentCategory',

	components: {
		Multiselect
	},

	data() {

		return {
			equipmentCategory: null,
			isNewEquipmentCategory: false,
			taggingOptions: [],
			existingTags: [],
			isSaving: false,
			isLoading: false,
		}
	},


	created() {

		// existing category - fetch the category ID from router
		if(this.$route.params.equipmentCategoryID && Number.isInteger(parseInt(this.$route.params.equipmentCategoryID)) ) {

			this.fetchData();

		}

		// new category
		else {

			this.isNewEquipmentCategory = true;

			// create new equipment obj with default values
			this.equipmentCategory = {
			    name: "",
			}

			// fetch tagging options
			this.getEquipmentCategoryAlias();

		}

	},

  computed: {

    title() {

        if(this.isNewEquipmentCategory == true) {
            return 'HEADER-NEW_EQUPIMENT_CATEGORY';
        } else {
            return this.equipmentCategory.name;
        }
    },

  },

	mounted() {

	},


	update() {

	},

	methods: {

		categoryAliasAdd(newTag) {

			this.taggingOptions.push({ name: newTag });
			this.existingTags.push({ name: newTag });

		},

		fetchData() {

			this.isLoading = true;
			var self = this;

			function getEquipmentCategory() {
				return self.axios.get(self.$config.api + 'equipmentCategory/' + self.$route.params.equipmentCategoryID + '?include=equipmentCategory.pages');
			}

			function getEquipmentCategoryAlias() {
        return self.axios.get(self.$config.api + 'equipmentCategoryAlias');
      }

      this.axios.all([getEquipmentCategory(), getEquipmentCategoryAlias()])
				.then(self.axios.spread(function (resCategory, resTags) {

					resCategory.data.aliases.forEach((tag, index) => {
						self.existingTags.push(tag.alias);
					});

					self.taggingOptions = resTags.data.equipmentCategoryAlias;

					self.equipmentCategory = resCategory.data;

					self.isLoading = false;

				})).catch(function(error) {
            console.log("ERROR: ", error);
        });

		},

		getEquipmentCategoryAlias() {

      this.axios.get(this.$config.api + 'equipmentCategoryAlias').then((res) => {
				this.taggingOptions = res.data.equipmentCategoryAlias;
			})

    },

		deleteEquipmentCategory() {

			var self = this;
			this.entityDelete('equipmentCategory', this.equipmentCategory.id, 'ECC-MSG-CONFIRM_DELETION').then(function(response) {
				self.$router.push({ name: 'equipmentCategories'} );
			})

		},

		submitForm() {

			if(!this.equipmentCategory.id) {

				this.entityCreateOrUpdate('equipmentCategory', this.equipmentCategory, { isSilent: true})
					.then((res) => {

						this.equipmentCategory = res;
						this.isNewEquipmentCategory = false;
						this.save();

					});

			} else {

				this.save();

			}

		},

		save() {

			if(this.existingTags && this.existingTags.length > 0) {

				let saveTag = null;
				this.equipmentCategory.aliases = [];

				this.existingTags.forEach( tag => {

					saveTag = {
						alias: tag,
						category: this.equipmentCategory.id
					}

					this.equipmentCategory.aliases.push(saveTag);

				});

			}

			this.entityCreateOrUpdate('equipmentCategory', this.equipmentCategory, { msg: 'MSG-SUCCESS-DATA_SAVE'});

		}

	}

}

</script>
